import image1 from "../../assets/lagooncleaning/lagoon2.jpeg";
import image2 from "../../assets/neerataping/neera1.jpeg";
import image3 from "../../assets/foodweb/food1.jpeg";
import image4 from "../../assets/gallery/REEF.jpg";
import image5 from "../../assets/gallery/REEF-1.jpg";
import image6 from "../../assets/gallery/REEF-2.jpg";
import image7 from "../../assets/gallery/REEF-3.jpg";
import image8 from "../../assets/gallery/REEF-4.jpg";
import image9 from "../../assets/gallery/REEF-5.jpg";
import image10 from "../../assets/gallery/REEF-59.jpg";
import image11 from "../../assets/gallery/REEF-60.jpg";
import image12 from "../../assets/gallery/REEF-8.JPG";
import image13 from "../../assets/gallery/REEF-9.jpg";
import image14 from "../../assets/gallery/REEF-10.jpg";
import image15 from "../../assets/gallery/REEF-11.jpg";
import image16 from "../../assets/gallery/REEF-12.jpg";
import image17 from "../../assets/gallery/REEF-13.jpg";
import image18 from "../../assets/gallery/REEF-14.jpg";
import image19 from "../../assets/gallery/REEF-15.JPG";
import image20 from "../../assets/gallery/REEF-16.JPG";
import image21 from "../../assets/gallery/REEF-17.JPG";
import image22 from "../../assets/gallery/REEF-18.JPG";
import image23 from "../../assets/gallery/REEF-19.JPG";
import image24 from "../../assets/gallery/REEF-20.JPG";
import image25 from "../../assets/gallery/REEF-21.JPG";
import image26 from "../../assets/gallery/REEF-23.jpg";
import image27 from "../../assets/gallery/REEF-25.jpg";
import image28 from "../../assets/gallery/REEF-26.jpg";
import image29 from "../../assets/gallery/REEF-27.JPG";
import image30 from "../../assets/gallery/REEF-28.JPG";
import image31 from "../../assets/gallery/REEF-28.JPG";
import image32 from "../../assets/gallery/REEF-29.jpg";
import image33 from "../../assets/gallery/REEF-30.jpg";
import image34 from "../../assets/gallery/REEF-31.jpg";
import image35 from "../../assets/gallery/REEF-32.jpg";
import image36 from "../../assets/gallery/REEF-33.JPG";
import image37 from "../../assets/gallery/REEF-34.jpg";
import image38 from "../../assets/gallery/REEF-35.jpg";
import image39 from "../../assets/gallery/REEF-36.jpg";
import image40 from "../../assets/gallery/REEF-37.jpg";
import image41 from "../../assets/gallery/REEF-38.JPG";
import image42 from "../../assets/gallery/REEF-39.jpg";
import image43 from "../../assets/gallery/REEF-40.jpg";
import image44 from "../../assets/gallery/REEF-41.jpg";
import image45 from "../../assets/gallery/REEF-42.JPG";
import image46 from "../../assets/gallery/REEF-43.jpg";
import image47 from "../../assets/gallery/REEF-44.jpg";
import image48 from "../../assets/gallery/REEF-45.jpg";
import image49 from "../../assets/gallery/REEF-46.jpg";
import image50 from "../../assets/gallery/REEF-47.JPG";

export const galleryData = [
  {
    id: 1,
    title: "Colosseum, Rome",
    location: "Italy",
    image: image1,
    description:
      "The Colosseum is an oval amphitheatre in the centre of the city of Rome, Italy. Built of travertine limestone, tuff, and brick-faced concrete, it was the largest amphitheatre ever built at the time and held 50,000 to 80,000 spectators.",
    date: "June 12, 2023",
    category: "Architecture",
    likes: 243,
    views: 1200,
  },
  {
    id: 2,
    title: "Burj Khalifa, Dubai",
    location: "Dubai",
    image: image2,
    description:
      "The Burj Khalifa is a skyscraper in Dubai, United Arab Emirates. It is the world's tallest building. With a total height of 829.8 m and a roof height of 828 m.",
    date: "July 5, 2023",
    category: "Architecture",
    likes: 187,
    views: 980,
  },
  {
    id: 3,
    title: "Big Ben, London",
    location: "London",
    image: image3,
    description:
      "Big Ben is the nickname for the Great Bell of the striking clock at the north end of the Palace of Westminster in London.",
    date: "August 19, 2023",
    category: "Landmark",
    likes: 321,
    views: 1560,
  },
  {
    id: 4,
    title: "Brandenburg Gate, Berlin",
    location: "Berlin",
    image: image4,
    description:
      "The Brandenburg Gate is an 18th-century neoclassical monument in Berlin, built on the orders of Prussian king Frederick William II.",
    date: "September 3, 2023",
    category: "Historical",
    likes: 198,
    views: 1120,
  },
  {
    id: 5,
    title: "Trevi Fountain, Rome",
    location: "Rome",
    image: image5,
    description:
      "The Trevi Fountain is a fountain in the Trevi district in Rome, designed by Italian architect Nicola Salvi and completed by Giuseppe Pannini.",
    date: "October 15, 2023",
    category: "Architecture",
    likes: 276,
    views: 1340,
  },
  {
    id: 6,
    title: "Eiffel Tower, Paris",
    location: "Paris",
    image: image6,
    description:
      "The Eiffel Tower is a wrought-iron lattice tower on the Champ de Mars in Paris, France. It is named after the engineer Gustave Eiffel.",
    date: "November 8, 2023",
    category: "Landmark",
    likes: 412,
    views: 2100,
  },
  {
    id: 7,
    title: "Sagrada Familia, Barcelona",
    location: "Barcelona",
    image: image7,
    description:
      "The Basílica de la Sagrada Família is a large unfinished minor basilica in Barcelona, designed by the Spanish architect Antoni Gaudí.",
    date: "December 12, 2023",
    category: "Architecture",
    likes: 345,
    views: 1780,
  },
  {
    id: 8,
    title: "Acropolis, Athens",
    location: "Athens",
    image: image8,
    description:
      "The Acropolis of Athens is an ancient citadel located on a rocky outcrop above the city of Athens.",
    date: "January 5, 2024",
    category: "Historical",
    likes: 289,
    views: 1450,
  },
  {
    id: 9,
    title: "Taj Mahal, Agra",
    location: "India",
    image: image9,
    description:
      "The Taj Mahal is an ivory-white marble mausoleum on the right bank of the river Yamuna in the Indian city of Agra.",
    date: "February 14, 2024",
    category: "Architecture",
    likes: 512,
    views: 2450,
  },
  {
    id: 10,
    title: "Great Wall, China",
    location: "China",
    image: image10,
    description:
      "The Great Wall of China is a series of fortifications that were built across the historical northern borders of ancient Chinese states.",
    date: "March 22, 2024",
    category: "Historical",
    likes: 421,
    views: 1980,
  },
  {
    id: 11,
    title: "Machu Picchu, Peru",
    location: "Peru",
    image: image11,
    description:
      "Machu Picchu is a 15th-century Inca citadel located in the Eastern Cordillera of southern Peru on a mountain ridge.",
    date: "April 10, 2023",
    category: "Historical",
    likes: 378,
    views: 1670,
  },
  {
    id: 12,
    title: "Statue of Liberty, New York",
    location: "New York",
    image: image12,
    description:
      "The Statue of Liberty is a colossal neoclassical sculpture on Liberty Island in New York Harbor within New York City.",
    date: "May 17, 2023",
    category: "Landmark",
    likes: 432,
    views: 2100,
  },
  {
    id: 13,
    title: "Sydney Opera House",
    location: "Sydney",
    image: image13,
    description:
      "The Sydney Opera House is a multi-venue performing arts centre in Sydney. It is one of the 20th century's most famous and distinctive buildings.",
    date: "June 5, 2023",
    category: "Architecture",
    likes: 367,
    views: 1890,
  },
  {
    id: 14,
    title: "Petra, Jordan",
    location: "Jordan",
    image: image14,
    description:
      "Petra is a historic and archaeological city in southern Jordan. It is famous for its rock-cut architecture and water conduit system.",
    date: "July 22, 2023",
    category: "Historical",
    likes: 298,
    views: 1540,
  },
  {
    id: 15,
    title: "Christ the Redeemer, Rio",
    location: "Rio de Janeiro",
    image: image15,
    description:
      "Christ the Redeemer is an Art Deco statue of Jesus Christ in Rio de Janeiro, Brazil, created by French sculptor Paul Landowski.",
    date: "August 30, 2023",
    category: "Landmark",
    likes: 456,
    views: 2230,
  },
  {
    id: 16,
    title: "Pyramids of Giza, Egypt",
    location: "Egypt",
    image: image16,
    description:
      "The Great Pyramid of Giza is the oldest and largest of the three pyramids in the Giza pyramid complex bordering present-day Giza in Egypt.",
    date: "September 14, 2023",
    category: "Historical",
    likes: 523,
    views: 2560,
  },
  {
    id: 17,
    title: "Santorini Sunset, Greece",
    location: "Greece",
    image: image17,
    description:
      "Santorini is one of the Cyclades islands in the Aegean Sea. It was devastated by a volcanic eruption in the 16th century BC.",
    date: "October 8, 2023",
    category: "Nature",
    likes: 612,
    views: 2890,
  },
  {
    id: 18,
    title: "Northern Lights, Iceland",
    location: "Iceland",
    image: image18,
    description:
      "The aurora borealis is a natural light display in Earth's sky, predominantly seen in high-latitude regions around the Arctic and Antarctic.",
    date: "November 20, 2023",
    category: "Nature",
    likes: 745,
    views: 3210,
  },
  {
    id: 19,
    title: "Grand Canyon, Arizona",
    location: "Arizona",
    image: image19,
    description:
      "The Grand Canyon is a steep-sided canyon carved by the Colorado River in Arizona, United States.",
    date: "December 3, 2023",
    category: "Nature",
    likes: 589,
    views: 2670,
  },
  {
    id: 20,
    title: "Venice Canals, Italy",
    location: "Venice",
    image: image20,
    description:
      "Venice, the capital of northern Italy's Veneto region, is built on more than 100 small islands in a lagoon in the Adriatic Sea.",
    date: "January 18, 2024",
    category: "Cityscape",
    likes: 478,
    views: 2310,
  },
  {
    id: 21,
    title: "Mount Fuji, Japan",
    location: "Japan",
    image: image21,
    description:
      "Mount Fuji is Japan's tallest mountain, standing at 3,776 meters. It is an active stratovolcano that last erupted in 1707-1708.",
    date: "February 25, 2024",
    category: "Nature",
    likes: 521,
    views: 2450,
  },
  {
    id: 22,
    title: "Angkor Wat, Cambodia",
    location: "Cambodia",
    image: image22,
    description:
      "Angkor Wat is a temple complex in Cambodia and is the largest religious monument in the world by land area.",
    date: "March 12, 2024",
    category: "Historical",
    likes: 432,
    views: 1980,
  },
  {
    id: 23,
    title: "Bali Rice Terraces, Indonesia",
    location: "Indonesia",
    image: image23,
    description:
      "The Jatiluwih rice terraces in Bali are a spectacular example of Subak, the traditional Balinese cooperative irrigation system.",
    date: "April 5, 2023",
    category: "Nature",
    likes: 567,
    views: 2540,
  },
  {
    id: 24,
    title: "Dubai Marina, UAE",
    location: "Dubai",
    image: image24,
    description:
      "Dubai Marina is a district in Dubai, United Arab Emirates. It is an artificial canal city built along a 3-kilometre stretch of Persian Gulf shoreline.",
    date: "May 19, 2023",
    category: "Cityscape",
    likes: 389,
    views: 1760,
  },
  {
    id: 25,
    title: "Sistine Chapel, Vatican",
    location: "Vatican City",
    image: image25,
    description:
      "The Sistine Chapel is a chapel in the Apostolic Palace, the official residence of the pope in Vatican City.",
    date: "June 28, 2023",
    category: "Art",
    likes: 421,
    views: 1890,
  },
  {
    id: 26,
    title: "Sahara Desert, Morocco",
    location: "Morocco",
    image: image26,
    description:
      "The Sahara is the largest hot desert in the world, located in North Africa. Its area of 9,200,000 square kilometers is comparable to the area of China.",
    date: "July 15, 2023",
    category: "Nature",
    likes: 498,
    views: 2230,
  },
  {
    id: 27,
    title: "Neuschwanstein Castle, Germany",
    location: "Germany",
    image: image27,
    description:
      "Neuschwanstein Castle is a 19th-century historicist palace on a rugged hill above the village of Hohenschwangau in southwest Bavaria, Germany.",
    date: "August 22, 2023",
    category: "Architecture",
    likes: 456,
    views: 2100,
  },
  {
    id: 28,
    title: "Iguazu Falls, Argentina/Brazil",
    location: "Argentina",
    image: image28,
    description:
      "Iguazu Falls are waterfalls of the Iguazu River on the border of the Argentine province of Misiones and the Brazilian state of Paraná.",
    date: "September 9, 2023",
    category: "Nature",
    likes: 612,
    views: 2780,
  },
  {
    id: 29,
    title: "Banff National Park, Canada",
    location: "Canada",
    image: image29,
    description:
      "Banff National Park is Canada's oldest national park, established in 1885. Located in the Rocky Mountains, it encompasses 6,641 square kilometers of mountainous terrain.",
    date: "October 17, 2023",
    category: "Nature",
    likes: 689,
    views: 3120,
  },
  {
    id: 30,
    title: "Alhambra, Spain",
    location: "Spain",
    image: image30,
    description:
      "The Alhambra is a palace and fortress complex located in Granada, Andalusia, Spain. It was originally constructed as a small fortress in 889 CE.",
    date: "November 5, 2023",
    category: "Architecture",
    likes: 432,
    views: 1980,
  },
  {
    id: 31,
    title: "Bora Bora, French Polynesia",
    location: "French Polynesia",
    image: image31,
    description:
      "Bora Bora is a small South Pacific island northwest of Tahiti in French Polynesia. Surrounded by sand-fringed motus (islets) and a turquoise lagoon.",
    date: "December 20, 2023",
    category: "Nature",
    likes: 745,
    views: 3450,
  },
  {
    id: 32,
    title: "Prague Castle, Czech Republic",
    location: "Czech Republic",
    image: image32,
    description:
      "Prague Castle is a castle complex in Prague, Czech Republic, dating from the 9th century. It is the official office of the President of the Czech Republic.",
    date: "January 8, 2024",
    category: "Historical",
    likes: 389,
    views: 1760,
  },
  {
    id: 33,
    title: "Serengeti Migration, Tanzania",
    location: "Tanzania",
    image: image33,
    description:
      "The Serengeti National Park is a Tanzanian national park in the Serengeti ecosystem in the Mara and Simiyu regions.",
    date: "February 14, 2024",
    category: "Wildlife",
    likes: 567,
    views: 2540,
  },
  {
    id: 34,
    title: "Santorini Blue Domes, Greece",
    location: "Greece",
    image: image34,
    description:
      "The iconic blue domes of Santorini are one of the most photographed sights in Greece, representing the traditional Cycladic architecture.",
    date: "March 22, 2024",
    category: "Architecture",
    likes: 612,
    views: 2890,
  },
  {
    id: 35,
    title: "Halong Bay, Vietnam",
    location: "Vietnam",
    image: image35,
    description:
      "Hạ Long Bay is a UNESCO World Heritage Site and popular travel destination in Quảng Ninh Province, Vietnam.",
    date: "April 10, 2023",
    category: "Nature",
    likes: 498,
    views: 2310,
  },
  {
    id: 36,
    title: "Matterhorn, Switzerland",
    location: "Switzerland",
    image: image36,
    description:
      "The Matterhorn is a mountain of the Alps, straddling the main watershed and border between Switzerland and Italy.",
    date: "May 27, 2023",
    category: "Nature",
    likes: 521,
    views: 2450,
  },
  {
    id: 37,
    title: "Forbidden City, Beijing",
    location: "China",
    image: image37,
    description:
      "The Forbidden City is a palace complex in central Beijing, China. It houses the Palace Museum, and was the former Chinese imperial palace.",
    date: "June 15, 2023",
    category: "Historical",
    likes: 456,
    views: 2100,
  },
  {
    id: 38,
    title: "Amalfi Coast, Italy",
    location: "Italy",
    image: image38,
    description:
      "The Amalfi Coast is a stretch of coastline on the northern coast of the Salerno Gulf on the Tyrrhenian Sea, located in the Province of Salerno of southern Italy.",
    date: "July 8, 2023",
    category: "Nature",
    likes: 678,
    views: 3120,
  },
  {
    id: 39,
    title: "Yellowstone National Park, USA",
    location: "USA",
    image: image39,
    description:
      "Yellowstone National Park is an American national park located in the western United States, largely in the northwest corner of Wyoming.",
    date: "August 25, 2023",
    category: "Nature",
    likes: 589,
    views: 2670,
  },
  {
    id: 40,
    title: "St. Basil's Cathedral, Moscow",
    location: "Russia",
    image: image40,
    description:
      "The Cathedral of Vasily the Blessed, commonly known as Saint Basil's Cathedral, is a church in Red Square in Moscow, Russia.",
    date: "September 12, 2023",
    category: "Architecture",
    likes: 432,
    views: 1980,
  },
  {
    id: 41,
    title: "Great Barrier Reef, Australia",
    location: "Australia",
    image: image41,
    description:
      "The Great Barrier Reef is the world's largest coral reef system composed of over 2,900 individual reefs and 900 islands.",
    date: "October 30, 2023",
    category: "Nature",
    likes: 745,
    views: 3450,
  },
  {
    id: 42,
    title: "Petronas Towers, Kuala Lumpur",
    location: "Malaysia",
    image: image42,
    description:
      "The Petronas Towers, also known as the Petronas Twin Towers, are twin skyscrapers in Kuala Lumpur, Malaysia.",
    date: "November 17, 2023",
    category: "Architecture",
    likes: 389,
    views: 1760,
  },
  {
    id: 43,
    title: "Cappadocia Hot Air Balloons, Turkey",
    location: "Turkey",
    image: image43,
    description:
      "Cappadocia is a historical region in Central Anatolia, Turkey. It is known for its unique geological features and hot air balloon rides at sunrise.",
    date: "December 5, 2023",
    category: "Adventure",
    likes: 812,
    views: 3780,
  },
  {
    id: 44,
    title: "Victoria Falls, Zambia/Zimbabwe",
    location: "Zambia",
    image: image44,
    description:
      "Victoria Falls is a waterfall on the Zambezi River in southern Africa, which provides habitat for several unique species of plants and animals.",
    date: "January 22, 2024",
    category: "Nature",
    likes: 567,
    views: 2540,
  },
  {
    id: 45,
    title: "Sossusvlei Dunes, Namibia",
    location: "Namibia",
    image: image45,
    description:
      "Sossusvlei is a salt and clay pan surrounded by high red dunes, located in the southern part of the Namib Desert, in the Namib-Naukluft National Park.",
    date: "February 9, 2024",
    category: "Nature",
    likes: 498,
    views: 2310,
  },
  {
    id: 46,
    title: "Siem Reap Temples, Cambodia",
    location: "Cambodia",
    image: image46,
    description:
      "Siem Reap is the capital city of Siem Reap Province in northwestern Cambodia. It is a popular tourist destination due to its proximity to Angkor Wat.",
    date: "March 18, 2024",
    category: "Historical",
    likes: 432,
    views: 1980,
  },
  {
    id: 47,
    title: "Plitvice Lakes, Croatia",
    location: "Croatia",
    image: image47,
    description:
      "Plitvice Lakes National Park is one of the oldest and largest national parks in Croatia. It is known for its chain of 16 terraced lakes.",
    date: "April 7, 2023",
    category: "Nature",
    likes: 612,
    views: 2890,
  },
  {
    id: 48,
    title: "Tokyo Skytree, Japan",
    location: "Japan",
    image: image48,
    description:
      "Tokyo Skytree is a broadcasting and observation tower in Sumida, Tokyo. It became the tallest structure in Japan in 2010 and reached its full height in 2012.",
    date: "May 24, 2023",
    category: "Architecture",
    likes: 421,
    views: 1890,
  },
  {
    id: 49,
    title: "Meteora Monasteries, Greece",
    location: "Greece",
    image: image49,
    description:
      "The Meteora is a rock formation in central Greece hosting one of the largest and most precipitously built complexes of Eastern Orthodox monasteries.",
    date: "June 11, 2023",
    category: "Religious",
    likes: 456,
    views: 2100,
  },
  {
    id: 50,
    title: "Salar de Uyuni, Bolivia",
    location: "Bolivia",
    image: image50,
    description:
      "Salar de Uyuni is the world's largest salt flat, at 10,582 square kilometers. It is in the Daniel Campos Province in Potosí in southwest Bolivia.",
    date: "July 29, 2023",
    category: "Nature",
    likes: 678,
    views: 3120,
  },
];
